import { paramsToQuery } from '@/base/MaUtils.js'
import { cacheRequest, makeRequest } from '@/base/MaRequestPooler.js'

export function fetchReviews({ trackId, region: regions, startDate, endDate }, optionalParams = {}) {
  return makeRequest(`/app/${trackId}/reviews?${paramsToQuery(Object.assign({
    regions,
    startDate,
    endDate,
  }, optionalParams))}`)
}

export function fetchRatings({ trackId, region: regions, startDate, endDate }, optionalParams) {
  return cacheRequest(`/app/${trackId}/ratings?${paramsToQuery(Object.assign({
    regions,
    startDate,
    endDate,
    offset: 0,
  }, optionalParams))}`)
}

export function wordDensity({ trackId, region: regions, startDate, endDate }, optionalParams = {}) {
  return cacheRequest(`/app/${trackId}/word-frequency?${paramsToQuery(Object.assign({
    regions,
    startDate,
    endDate,
  }, optionalParams))}`)
}

export function createOrUpdateReviewReply({ trackId, reviewId, dbId, data }) {
  return makeRequest(`/account/store-account/app/${trackId}/review/${reviewId}?id=${dbId}`, {
    method: 'POST',
    data: { payload: data },
  })
}

export function deleteReviewReply({ trackId, reviewId, responseId, dbId }) {
  return makeRequest(`/account/store-account/app/${trackId}/review/${reviewId}/response/${responseId}?id=${dbId}`, {
    method: 'DELETE',
  })
}
export function getReviewReply({ trackId, reviewId, dbId }) {
  return makeRequest(`/account/store-account/app/${trackId}/review/${reviewId}?id=${dbId}`)
}
